<template>
  <container :class="{ 'is-in-sdk': isInSdk }">
    <div class="wrap">
      <div
        class="custom-input"
        :class="$platformClass"
        v-if="canSelectGameInfo"
      >
        <label for>
          <span>*</span>
          <span class="label-span">{{ letters._game }}</span>
        </label>
        <a
          v-if="canSelectGameInfo && canSelectGame"
          href="javascript:;"
          @click.prevent="callSelect('game_id')"
        >
          <Icon type="serviceInput" class="custom-input-icon"></Icon>
          {{ placeholder.game || letters._gameHolder }}
        </a>
        <a v-else href="javascript:;">
          {{ placeholder.game || letters._gameHolder }}
        </a>
      </div>
      <div
        class="custom-input"
        :class="$platformClass"
        v-if="canSelectGameInfo"
      >
        <label for>
          <span>*</span>
          <span class="label-span">{{ letters._server }}</span>
        </label>
        <a
          v-if="canSelectGameInfo"
          href="javascript:;"
          @click.prevent="callSelect('server_id')"
        >
          <Icon type="serviceInput" class="custom-input-icon"></Icon>
          {{ placeholder.server || letters._serverHolder }}
        </a>
        <a v-else href="javascript:;">
          {{ placeholder.server || letters._serverHolder }}
        </a>
      </div>
      <div
        class="custom-input"
        :class="$platformClass"
        v-if="canSelectGameInfo && needRole"
      >
        <label for>
          <span class="label-span">{{ letters._role }}</span>
        </label>
        <a
          v-if="canSelectGameInfo"
          href="javascript:;"
          @click.prevent="callSelect('role_id')"
        >
          <Icon type="serviceInput" class="custom-input-icon"></Icon>
          {{ placeholder.role }}
        </a>
        <a v-else href="javascript:;">{{ placeholder.role }}</a>
      </div>
      <div class="custom-user-info" v-if="!canSelectGameInfo">
        <div class="left-content">
          <Icon type="userInfoDefaultAvatar" class="user-avatar"></Icon>
        </div>
        <div class="right-content" :class="$platformClass">
          <span class="line ocean-ui-icon-line"></span>
          <span class="right-content_top ocean-ui-icon-custom">
            {{ placeholder.role }}
          </span>
          <span class="right-content_bottom" :class="$platformClass">
            <span class="right-content_bottom-left">
              {{ placeholder.game || letters._gameHolder }}
            </span>
            <span class="right-content_bottom-right">
              {{ letters._server
              }}{{ placeholder.server || letters._serverHolder }}
            </span>
          </span>
        </div>
      </div>
      <div class="custom-input" :class="$platformClass">
        <label for>
          <span>*</span>
          <span class="label-span">{{ letters._create }}:</span>
        </label>
        <a
          href="javascript:;"
          @click.prevent="callSelect('create')"
          :class="placeholder.create ? false : 'default'"
        >
          <Icon type="serviceInput" class="custom-input-icon"></Icon>
          {{ placeholder.create || letters._createHolder }}
        </a>
      </div>
      <div class="custom-input" :class="$platformClass">
        <label for>
          <span>*</span>
          <span class="label-span">{{ letters._title }}:</span>
        </label>
        <input
          type="text"
          v-model="workParams.subject"
          :placeholder="letters._titleHolder"
        />
      </div>
      <div class="custom-input" :class="$platformClass">
        <label for>
          <span>*</span>
          <span class="label-span">{{ letters._detail }}:</span>
        </label>
        <textarea
          v-model="workParams.message"
          :placeholder="letters._detailHolder"
        ></textarea>
      </div>
      <div class="img-preview-list">
        <div
          class="img-preview-list-item"
          :class="$platformClass"
          v-for="(image, i) in previewList"
          :key="i"
        >
          <img :src="image" alt v-image-preview />
          <div
            class="loading"
            v-if="showLoading && i === previewList.length - 1"
          >
            <i class="loading-icon"></i>
          </div>
          <a
            href="javascript:;"
            @click="deleteImage(i)"
            :class="$platformClass"
            class="img-preview-list-item-delete"
          ></a>
        </div>
        <!-- 第三方图片上传插件 -->
        <vue-core-image-upload
          v-if="previewList.length < 3"
          class="btn btn-primary"
          :class="$platformClass"
          :crop="false"
          @imagechanged="addImage"
          @errorhandle="imageErrorHandle"
          :max-file-size="20971520"
          :multiple="true"
          :text="''"
          :isXhr="false"
          :inputAccept="'image/*'"
          :extensions="'png,jpg,jpeg,gif'"
        >
          <a
            href="javascript:;"
            class="upload-image-btn"
            :class="$platformClass"
          ></a>
        </vue-core-image-upload>
      </div>
      <p
        class="limit"
        :class="$platformClass"
        v-if="isAndroidJpDzg"
        v-html="letters._permitTips"
      ></p>
      <p class="limit" :class="$platformClass">{{ letters._uploadTips }}</p>
    </div>
    <div class="submit">
      <Button
        href="javascript:;"
        class="submit-btn"
        @click="submitWork"
        data-asyncbtn="create-work-btn"
        type="createWorkBtn"
      >
        {{ letters._submit }}
        <!-- <i class="submit-btn-check"></i> -->
        <Icon type="createWorkBtnLeft"></Icon>
        <Icon type="createWorkBtnRight"></Icon>
        <Icon
          v-if="!$isOmni"
          type="submitBtnCheck"
          class="submit-btn-check"
        ></Icon>
      </Button>
    </div>
    <select-box
      :open="selectBox.showSelectBox"
      :list="selectBox.selectList"
      :title="selectBox.selectTile"
      :type="selectBox.type"
      :selectedIndex="selectBox.selectedIndex"
      :showSearch="selectBox.showSearch"
      :searchText="selectBox.searchText"
      @select="selectCallback"
      @close="closeSelect"
    ></select-box>
    <success-popup
      :open="successPopup.show"
      :msg="successPopup.msg"
      @toggle="toggleSuccess"
    ></success-popup>
  </container>
</template>
<script>
import {
  TOAST,
  CLOSE_TOAST,
  OPEN_IMAGE_PREVIEW
} from '../../store/support/event-type.js';

import container from '../../components/support/Container.vue';
import selectBox from '../../components/support/selectBox.vue';
import successPopup from '../../components/support/successPopup.vue';
import * as SelectBoxType from '../../components/support/SelectBoxType';
import getLetters from '../../mixins/getLetters.js';
import VueCoreImageUpload from 'vue-core-image-upload';
import globalConfig from '../../utiles/globalConfig.js';
import { getFileExtension } from '../../utiles';
import { mapActions, mapMutations } from 'vuex';
import Compressor from 'compressorjs';
import bridge from '@utiles/bridge';

export default {
  name: 'create-work',
  mixins: [getLetters],
  beforeCreate() {
    globalConfig.storeEntryParams();
  },
  created: function () {
    let gameId = globalConfig.getHrefParam('gameId');
    let serverId = globalConfig.getHrefParam('serverId');
    let roleName = globalConfig.getHrefParam('roleName');
    let roleId = globalConfig.getHrefParam('roleId');
    if (
      !this.isUidLogin ||
      !this.uidGame ||
      (this.uidGame && globalConfig.getHrefParam('uid') == '')
    ) {
      /**
       * 越南大掌柜工单页接口特殊处理
       * 包括工单页在内，储值页和官网都更换了域名dcqvn.com需要进行兼容处理，默认使用的是/src/resource/utiles.js中UID_GAME_CONFIG的requestName，
       * 但该js中UID_GAME_CONFIG的requestName使用地方众多，且还有其它接口和链接用到，暂时先特殊处理
       */
      const loginFn = gameId == 215 ? this.checkLoginDcqvn : this.checkLogin;
      loginFn().then(({ res }) => {
        if (parseInt(res.result, 10) === 1) {
          this.needRole = true;
        } else {
          this.needRole = false;
        }
      });
    } else {
      this.needRole = true;
    }

    let workParams = this.workParams;
    if (gameId && serverId && roleId) {
      this.canSelectGameInfo = 0;
      workParams.game_id = gameId;
      workParams.game_server_id = serverId;
      workParams.character_name = roleName;
      this.getUserInfo({
        game_id: gameId,
        server_id: serverId,
        role_id: roleId
      }).then(
        function ({ res }) {
          if (res.result === 1) {
            this.placeholder.game = this.formatGameName(res.data.gameName);
            this.placeholder.server = res.data.serverName;
            this.placeholder.role = roleName || res.data.charName;
          }
        }.bind(this)
      );
    } else if (gameId) {
      this.onlyGameId = 1;
      this.callSelect('game_id', true);
    } else {
      this.callSelect('game_id', true);
    }
  },
  data: () => {
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('gameID') ||
      globalConfig.getHrefParam('game_id') ||
      '';
    console.log('isUidLogin:', +globalConfig.getHrefParam('isUidLogin') === 1);
    return {
      isUidLogin: +globalConfig.getHrefParam('isUidLogin') === 1, // 末日新版第三方储值页使用uid登录时，跳工单无需登录态
      uidGame: globalConfig.isUidGame(),
      canSelectGameInfo: 1,
      canSelectGame: 1,
      onlyGameId: 0,
      needRole: false,
      workParams: {
        category_id: undefined,
        game_id: undefined,
        game_server_id: undefined,
        character_name: undefined,
        message: undefined,
        pic: [],
        pic_compress: [] // 对应图片是否压缩标识别 1:压缩 0:未压缩
      }, // 用于提交的工单参数
      previewList: [], // 预览图片列表，base64格式
      selectBox: {
        showSelectBox: false,
        selectList: [],
        selectTile: '',
        variableName: '',
        selectedIndexs: [-1, -1, -1, -1],
        selectedIndex: -1,
        type: SelectBoxType.GAME,
        showSearch: false,
        searchText: ''
      }, // 通用选择框参数
      successPopup: {
        show: false,
        msg: ''
      }, // 提交成功的弹窗内容
      placeholder: {
        game: '',
        server: '',
        role: '',
        create: ''
      }, // 在通用弹窗选择的结果
      showLoading: false,
      gameList: [],
      serverList: [],
      roleList: [],
      isAndroidJpDzg:
        +gameId === 209 &&
        globalConfig.getHrefParam('devicePlate') === 'android',
      isInSdk: bridge.runInsdk()
    };
  },
  computed: {
    getGameId: function () {
      return this.workParams.game_id;
    },
    getServerId: function () {
      return this.workParams.game_server_id;
    }
  },
  watch: {
    gameList: {
      handler() {
        this.autoSelectGame();
      },
      deep: true
    },
    getGameId: {
      handler() {
        if (this.canSelectGameInfo && this.workParams.game_id) {
          this.serverList = [];
          this.callSelect('server_id', true);
        }
      }
    },
    getServerId: {
      handler() {
        if (
          this.canSelectGameInfo &&
          this.needRole &&
          this.workParams.game_server_id
        ) {
          this.roleList = [];
          this.callSelect('role_id', true);
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'createWork',
      'uploadImg',
      'getGameList',
      'getServerList',
      'getCharName',
      'getCharNameDcqvn',
      'getUserInfo',
      'checkLogin',
      'checkLoginDcqvn'
    ]),
    ...mapMutations([TOAST, CLOSE_TOAST, OPEN_IMAGE_PREVIEW]),
    // 格式化特殊游戏显示
    formatGameName(gameName) {
      if (
        +this.workParams.game_id === 195 &&
        globalConfig.getMainHost() === atob('ZW5kb21haW5uYW1lLmNvbQ==')
      ) {
        return 'Soul Land ตำนานจอมยุทธ์ภูตถังซาน';
      }
      return gameName;
    },
    /**
     * 调起通用选择框，根据传入参数分别选择游戏、服务器、角色
     * @param {string} type
     */
    callSelect: (function () {
      let strategy = {
        game_id: function (isHideSelect) {
          if (this.gameList.length) {
            this.handleSelectBox('game_id', isHideSelect);
          } else {
            let game_id = globalConfig.getHrefParam('gameId') || '';
            this.getGameList(game_id).then(({ res }) => {
              if (res.result === 1) {
                this.gameList = res.data;
                this.handleSelectBox('game_id', isHideSelect);
              }
            });
          }
        },
        server_id: function (isHideSelect) {
          let game_id = this.workParams.game_id;
          if (!game_id) {
            this[TOAST](this.letters._gameHolder);
            return;
          }
          if (this.serverList.length) {
            this.handleSelectBox('server_id', isHideSelect);
          } else {
            this.getServerList(game_id).then(({ res }) => {
              if (res.result === 1) {
                this.serverList = res?.data;
                this.handleSelectBox('server_id', isHideSelect);
              } else {
                this[TOAST](res?.msg);
              }
            });
          }
        },
        role_id: function (isHideSelect) {
          let { game_server_id, game_id } = this.workParams;
          if (!game_id) {
            this[TOAST](this.letters._gameHolder);
            return;
          }
          if (!game_server_id) {
            this[TOAST](this.letters._serverHolder);
            return;
          }
          if (this.roleList.length) {
            this.handleSelectBox('role_id', isHideSelect);
          } else {
            /**
             * 越南大掌柜工单页接口特殊处理
             * 包括工单页在内，储值页和官网都更换了域名dcqvn.com需要进行兼容处理，默认使用的是/src/resource/utiles.js中UID_GAME_CONFIG的requestName，
             * 但该js中UID_GAME_CONFIG的requestName使用地方众多，且还有其它接口和链接用到，暂时先特殊处理
             */
            const getCharNameFn =
              game_id == 215 ? this.getCharNameDcqvn : this.getCharName;
            getCharNameFn({ server_id: game_server_id, game_id }).then(
              ({ res }) => {
                if (res.result === 1) {
                  this.roleList = res?.data;
                  this.handleSelectBox('role_id', isHideSelect);
                } else {
                  this[TOAST](res.data ? res.data?.msg : res?.msg);
                }
              }
            );
          }
        },
        create: function () {
          this.handleSelectBox('create');
        }
      };
      return function (type, isHideSelect) {
        strategy[type].call(this, isHideSelect);
      };
    })(),
    closeSelect: function () {
      this.selectBox.showSelectBox = false;
      this.selectBox.showSearch = false;
      this.selectBox.searchText = '';
    },
    toggleSuccess: function () {
      this.successPopup.show = !this.successPopup.show;
    },
    /**
     * 关闭通用选择框之后的回调，写入对应的选择结果
     * @param {string} type
     */
    selectCallback: (function () {
      let strategy = {
        game_id: function (index) {
          this.workParams.game_id = this.gameList[index].ID;
          this.placeholder.game = this.formatGameName(
            this.gameList[index].NAME
          );
          this.workParams.game_server_id = '';
          this.workParams.server_id = '';
          this.placeholder.server = '';
          this.workParams.character_name = '';
          this.workParams.role_id = '';
          this.placeholder.role = '';
          this.selectBox.selectedIndexs[0] = index;
          this.selectBox.selectedIndexs[1] = -1;
          this.selectBox.selectedIndexs[2] = -1;
        },
        server_id: function (index) {
          this.workParams.game_server_id = this.serverList[index].SID;
          this.placeholder.server = this.serverList[index].REAL_NAME;
          this.workParams.character_name = '';
          this.workParams.role_id = '';
          this.placeholder.role = '';
          this.selectBox.selectedIndexs[1] = index;
          this.selectBox.selectedIndexs[2] = -1;
        },
        role_id: function (index) {
          this.workParams.character_name = this.roleList[index].roleName;
          this.placeholder.role = this.roleList[index].roleName;
          this.selectBox.selectedIndexs[2] = index;
        },
        create: function (index) {
          this.workParams.category_id = index + 1;
          this.placeholder.create = this.letters._selectBox.selectList[index];
          this.selectBox.selectedIndexs[3] = index;
        }
      };
      return function (index) {
        let variableName = this.selectBox.variableName;
        strategy[variableName].call(this, index);
      };
    })(),
    addImage(res) {
      function addPic(res, self) {
        let img = res;
        if (img.size > 4 * 1024 * 1024) {
          try {
            new Compressor(
              new window.File([img], img.name, { type: 'image/jpeg' }),
              {
                quality: 0.7,
                success(miniResult) {
                  self.handleUploadImg(miniResult, self, true);
                },
                error(err) {
                  console.log(err.message);
                }
              }
            );
          } catch (error) {
            self.handleUploadImg(img, self, false);
          }
        } else {
          self.handleUploadImg(img, self, false);
        }
      }
      try {
        let len = res.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            addPic(res[i], this);
          }
        } else {
          addPic(res, this);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // handleUploadImgOld(img, self, isCompress) {
    //   let reader = new FileReader();
    //   let vm = self;
    //   reader.onload = function () {
    //     let imgData = this.result;
    //     if (imgData?.length > 9 * 1024 * 1024) {
    //       //大于4MB的图片压缩后base64还是大于9MB，不允许上传 提示上传错误
    //       vm[TOAST](vm.letters._uploadTips);
    //       return;
    //     }
    //     vm.previewList.push(imgData);
    //     vm.showLoading = true;

    //     vm.uploadImg({ content: [imgData] }).then(res => {
    //       let url = (res.data && res.data?.IMG_URL[0]) || '';
    //       if (res.result === 1) {
    //         vm.successPopup.msg = res?.msg;
    //         vm.showLoading = false;
    //         vm.workParams.pic.push(url);
    //         vm.workParams.pic_compress.push(+isCompress);
    //       } else {
    //         vm.showLoading = false;
    //         vm.toast(res?.msg);
    //       }
    //     });
    //   };
    //   reader.readAsDataURL(img);
    // },
    // post请求
    post(url, formData) {
      // 打印时间戳
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              const res = JSON.parse(xhr.responseText);
              if (res.result === 1) {
                // console.log(res);
                resolve(res);
              } else {
                reject(res);
              }
            } else {
              reject(xhr.responseText);
            }
          }
        };
        xhr.send(formData);
      });
    },
    async handleUploadImg(img, self, isCompress) {
      // 获取图片的类型(jpg/png/gif/webp?...)
      const fileType = getFileExtension(img);
      const vm = self;
      const file = img;
      const LENGTH = 1024 * 1024 * 0.2; // 0.5M每个chunk
      const that = this;
      let chunks = that.slice(file, LENGTH);
      // 获取对于同一个文件，获取其的context
      let context = that.createContext(file);
      // 获取上传记录
      let record = await that.getUploadSliceRecord(context, chunks);
      let tasks = [];
      vm.previewList.push(URL.createObjectURL(file));
      vm.showLoading = true;
      chunks.forEach((chunk, index) => {
        // 已上传的切片则不再重新上传
        if (!record.includes(index + 1)) {
          return;
        }
        let fd = new FormData();
        fd.append('file', chunk);
        fd.append('context', context);
        fd.append('chunk', index + 1);
        fd.append('type', 'support_order');
        fd.append('e_info', globalConfig.getHrefParam('e_info'));
        fd.append('user_id_cross', globalConfig.getHrefParam('uid') || '');
        fd.append(
          'login_account',
          globalConfig.getHrefParam('loginAccount') || ''
        );
        let task = that
          .post(
            'https://gsupport.' +
              globalConfig.getMainHost() +
              '/index/uploadImg2',
            fd
          )
          .then(res => {
            if (+res.result) {
              record.push(index);
            }
          });
        tasks.push(task);
      });
      // 所有切片上传完毕后，调用mkfile接口
      Promise.all(tasks)
        .then(res => {
          let fd = new FormData();
          fd.append('context', context);
          fd.append('chunks', chunks.length);
          fd.append('file_ext', fileType);
          that
            .post(
              'https://gsupport.' +
                globalConfig.getMainHost() +
                '/index/mkFile',
              fd
            )
            .then(res => {
              let url = (res.data && res.data?.IMG_URL[0]) || '';
              if (res.result === 1) {
                vm.successPopup.msg = res?.msg;
                vm.showLoading = false;
                vm.workParams.pic.push(url);
                vm.workParams.pic_compress.push(+isCompress);
              } else {
                vm.showLoading = false;
                vm.toast(res?.msg);
              }
            });
        })
        .catch(error => {
          console.error(error);
        });
    },
    // 获取未上传切片记录
    async getUploadSliceRecord(context, chunks) {
      let fd = new FormData();
      fd.append('context', context);
      fd.append('chunks', chunks.length);
      fd.append('file_ext', fileType);
      const response = await this.post(
        'https://gsupport.' +
          globalConfig.getMainHost() +
          '/index/getUnUploadChunks',
        fd
      );
      return +response.result === 1 ? response.data?.UnUploadChunks : [];
    },
    // 获取context，同一个文件会返回相同的值
    createContext(file) {
      return file.name + file.size;
    },
    // 切片
    slice(file, piece = 1024 * 1024 * 5) {
      let totalSize = file.size; // 文件总大小
      let start = 0; // 每次上传的开始字节
      let end = start + piece; // 每次上传的结尾字节
      let chunks = [];
      while (start < totalSize) {
        // 根据长度截取每次需要上传的数据
        // File对象继承自Blob对象，因此包含slice方法
        let blob = file.slice(start, end);
        chunks.push(blob);
        start = end;
        end = start + piece;
      }
      return chunks;
    },
    /* eslint-disable    handle-callback-err */
    imageErrorHandle(err) {
      this[TOAST](this.letters._uploadTips);
    },
    deleteImage: function (i) {
      this.workParams.pic.splice(i, 1);
      this.workParams.pic_compress.splice(i, 1);
      this.previewList.splice(i, 1);
    },
    submitWork() {
      let vm = this;
      let params = vm.workParams && JSON.parse(JSON.stringify(vm.workParams));
      const orderId = globalConfig.getHrefParam('orderId');
      if (orderId) {
        params.message = params.message + '；訂單號:' + orderId;
      }
      params.pic = JSON.stringify(params.pic);
      params.pic_compress = JSON.stringify(params.pic_compress);
      const packageVersion = globalConfig.getHrefParam('packageVersion') || '';
      params.package_version = packageVersion;
      this.createWork(params).then(res => {
        if (res.data.result === 1) {
          vm.successPopup.msg = res.data.msg;
          vm.toggleSuccess();
        }
        this.$clearDisable('create-work-btn');
      });
    },
    // 当只有gameid的时候，依旧自动选择游戏，并禁止选择其他游戏，该操作只操作一遍
    autoSelectGame() {
      if (this.onlyGameId) {
        let gameId = globalConfig.getHrefParam('gameId');
        let realGameIndex = null;
        this.gameList.map((item, index) => {
          if (item.ID == gameId) {
            realGameIndex = index;
          }
        });
        if (realGameIndex !== null) {
          this.onlyGameId = 0;
          this.selectCallback(realGameIndex);
          this.canSelectGame = 0;
        }
      }
    },
    objectArrToStringArr(arr, prop) {
      let result = [];
      let length = arr.length;
      for (let i = 0; i < length; i++) {
        result.push(arr[i][prop]);
      }
      return result;
    },
    handleSelectBox(type, isHideSelect) {
      switch (type) {
        case 'game_id': {
          this.selectBox.selectList = this.objectArrToStringArr(
            this.gameList,
            'NAME'
          );
          this.selectBox.type = SelectBoxType.GAME;
          this.selectBox.variableName = 'game_id';
          if (!isHideSelect) {
            this.selectBox.showSelectBox = true;
            this.selectBox.selectedIndex = this.selectBox.selectedIndexs[0];
          }
          this.selectBox.selectTile = this.letters._game;
          break;
        }
        case 'server_id': {
          this.selectBox.type = SelectBoxType.SERVER;
          this.selectBox.variableName = 'server_id';
          if (!this.serverList.length) {
            this[TOAST](this.letters._noServer);
            return;
          } else {
            this.selectBox.selectList = this.objectArrToStringArr(
              this.serverList,
              'REAL_NAME'
            );
          }
          if (!isHideSelect) {
            this.selectBox.showSearch = true;
            this.selectBox.searchText = this.letters._search;
            this.selectBox.showSelectBox = true;
            this.selectBox.selectedIndex = this.selectBox.selectedIndexs[1];
          }
          this.selectBox.selectTile = this.letters._server;
          break;
        }
        case 'role_id': {
          this.selectBox.type = SelectBoxType.ROLE;
          this.selectBox.selectedIndex = this.selectBox.selectedIndexs[2];
          if (!this.roleList.length) {
            this[TOAST](this.letters._noRole);
            return;
          } else {
            this.selectBox.selectList = this.objectArrToStringArr(
              this.roleList,
              'roleName'
            );
          }
          this.selectBox.variableName = 'role_id';
          if (!isHideSelect) {
            this.selectBox.showSelectBox = true;
          }
          this.selectBox.selectTile = this.letters._role;
          break;
        }
        case 'create': {
          this.selectBox.selectList = this.letters._selectBox.selectList;
          this.selectBox.selectTile = this.letters._selectBox.selectTile;
          this.selectBox.showSelectBox = true;
          this.selectBox.variableName = 'create';
          this.selectBox.type = SelectBoxType.QUESSION;
          this.selectBox.selectedIndex = this.selectBox.selectedIndexs[3];
          break;
        }
      }
    }
  },
  components: {
    container,
    selectBox,
    VueCoreImageUpload,
    successPopup
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5);
  &-icon {
    @include size(50, 50);
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    @include bgPng('loading');
    display: inline-block;
    animation: circle linear 1s infinite;
  }
}
.custom-user-info {
  margin-top: 32px;
  overflow: hidden;
  box-sizing: border-box;
  .left-content {
    width: 120px;
    height: 120px;
    border-radius: 120%;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    .user-avatar {
      width: 100%;
      height: 100%;
      display: inline-block;
      background-image: url($imgSupport + 'user-avatar.png');
    }
  }
  .right-content {
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
    height: 120px;
    font-size: 0;
    position: relative;
    width: calc(100% - 140px);
    // overflow: hidden;
    .line {
      position: absolute;
      display: block;
      top: 50%;
      left: -10px;
      content: '';
      width: 2px;
      height: 84px;
      margin-top: -42px;
    }
    &_top {
      display: block;
      height: 60px;
      font-size: 28px;
      line-height: 60px;
    }
    &_bottom {
      display: block;
      height: 60px;
      font-size: 24px;
      color: #3b3b3b;
      line-height: 60px;
      &-right {
        margin-left: 38px;
      }
    }
  }
}
.custom-input {
  width: 100%;
  margin-top: 30px;
  label {
    height: 42px;
    width: 100%;
    display: block;
    color: #414141;
    margin-bottom: 5px;
    // font-size: 24px;
    // font-weight: bold;
    // line-height: 42px;
    padding-left: 12px;
    font-size: 0;
    span {
      color: #a9a9a9;
      font-size: 22px;
      // font-size: 30px;
    }
    .label-span {
      margin-left: 5px;
      font-size: 26px;
      color: #3b3b3b;
    }
  }
  &-icon {
    float: right;
    margin-top: 36px;
    @include size(14, 8);
    display: inline-block;
    @include bgPng('triangle-down');
    vertical-align: text-bottom;
  }
  input,
  a,
  textarea {
    width: 100%;
    height: 80px;
    display: block;
    line-height: 80px;
    padding: 0 32px;
    border: solid 1px #dfdfdf;
    color: #3b3b3b;
    font-size: 24px;
  }
  a.default {
    color: #a9a9a9;
  }
  textarea {
    height: 280px;
    padding-top: 16px;
    line-height: 28px;
  }
  input,
  textarea {
    &::-webkit-input-placeholder {
      color: #a9a9a9;
    }
    &:-moz-placeholder {
      color: #a9a9a9;
    }
    &::-moz-placeholder {
      color: #a9a9a9;
    }
    &:-ms-input-placeholder {
      color: #a9a9a9;
    }
  }
}
.img-preview-list {
  width: 100%;
  margin-top: 30px;
  &-item {
    @include size(150, 150);
    position: relative;
    margin-right: 30px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
      display: inline-block;
    }
    &-delete {
      @include size(30, 30);
      display: inline-block;
      @include bgPng('delete-icon');
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 9;
    }
  }
}
.upload-image-btn {
  @include size(150, 150);
  display: inline-block;
  position: relative;
  @include bgPng('add-icon');
  background-size: 30px 30px;
  background-position: center center;
  @include bgC(#dfdfdf);
}
/*覆盖插件样式*/
.btn-primary {
  width: 150px;
  display: inline-block;
}
.limit {
  margin-top: 19px;
  font-size: 24px;
  color: #7a7a7a;
}
.submit {
  width: 100%;
  padding: 0 30px;
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 9;
  &-btn {
    width: 100%;
    height: 80px;
    line-height: 80px;
    display: block;
    @include bgC(#5fd193);
    color: #fff;
    font-size: 30px;
    text-align: center;
    &-check {
      @include size(26, 19);
      display: inline-block;
      @include bgPng('tiny-check-icon');
    }
  }
}
.wrap {
  height: 100%;
  padding-bottom: 150px;
  overflow-y: scroll;
}

.is-in-sdk {
  $safeBottomDis: 60px;
  .submit {
    bottom: 30px + $safeBottomDis;
  }
  .wrap {
    padding-bottom: 150px + $safeBottomDis;
  }
}
</style>
